document.documentElement.className = document.documentElement.className.replace(/\bno-js\b/g, "") + "js"

if (window.location.hash) { setTimeout(function () { window.scrollTo(0, 0); }, 2); }

jQuery(document).ready(function ($) {

    /*-----------------------------------------------------------------------------GLOBAL ON LOAD----*/

    var LazyLoading = (function () {
        var instance = new LazyLoad();

        function setMobileImages() {
            var $bgImageSets = $('[data-bg-mobile]');

            if ($bgImageSets.length) {
                $bgImageSets.each(function () {
                    var $this = $(this);
                    var mobile = $this.data('bg-mobile');

                    if (window.innerWidth < 720) {
                        $this.attr('data-bg', mobile);
                    }
                });
            }
        }

        function lazyBGImages() {
            var $bgImages = $('[data-bg]:not(.lazy)');

            if ($bgImages.length) {
                $bgImages.each(function () {
                    $(this).addClass('lazy');
                });
            }

            setMobileImages();
            instance.update();
        }

        function update() {
            lazyBGImages();
        }

        lazyBGImages();

        return {
            update: update
        }
    }());

    var urlParams = (function (strParam) {
        var objParams = {};

        function init() {

            objParams = {};
            var arrURLParams = window.location.search.replace('?', '').split('&');
            arrURLParams.map(function (val) {
                var arrPair = val.split('=');
                objParams[arrPair[0]] = decodeURIComponent(arrPair[1]);
            });
        }
        init();
        return {
            get: function (strParam) {
                return objParams[strParam];
            },
            pull: init
        };
    }());

    var SmoothScroll = (function () {

        function goTo(target) {
            if (target === "" || !$(target).length) { return; }
            var scrollPos = typeof target === 'number' ? target : $(target).offset().top;

            if (window.innerWidth >= 720) {
                scrollPos -= $('header').outerHeight();
            } else {
                scrollPos -= $('header').outerHeight() * 2;
            }

            $('html, body').stop().animate({
                'scrollTop': scrollPos - 64
            }, 1200, 'swing', function () {
                if (typeof target === 'string') {

                    if (window.location.hash) {
                        // window.location.hash = target;
                    }
                }
            });
        }

        function init() {
            var $anchorLinks = $('a[href^="#"]').not('a[href="#"]');

            $('a[href="#"]').click(
                function (e) { e.preventDefault(); return; }
            );

            if (window.location.hash) {
                setTimeout(function () {
                    goTo(window.location.hash);
                }, 500);
            }

            if ($anchorLinks.length) {
                $anchorLinks.on('click', function (e) {
                    if (!$("#" + this.hash.replace('#', '')).length) { return; }
                    e.preventDefault();
                    goTo(this.hash);
                });
            }
        }

        init();

        return { to: goTo, refresh: init }
    }());

    //Global function to toggle simple accordions
    var Accordions = () => {
        var $accordions = $('.accordion');
        if (!$accordions.length) { return; }

        $accordions.each(function () {
            if ($(this).hasClass('active')) {
                $(this).find('.accordion__content').show();
            }
        });

        $accordions.find('.accordion__trigger').click(function (e) {
            var $this = $(this);
            var $accordion = $this.parent();
            var $content = $accordion.find('.accordion__content');
            var $siblings = $accordion.siblings().length ? $accordion.siblings() : $accordions.filter('[data-group="' + $accordion.data('group') + '"]');

            if ($accordion.hasClass('active')) {
                $accordion.removeClass('active');
                $content.stop().slideUp('fast');
            } else {
                $siblings.removeClass('active').find('.accordion__content').stop().slideUp('fast');
                $accordion.addClass('active');
                $content.stop().slideDown('fast');
            }
        })
    }

    Accordions();

    var Forms = (function () {
        var InputMasks = (function () {
            var $masks = $('[data-mask]');
            if (!$masks.length) { return; }

            /**
             * Key Codes:
             * 8    - backspace
             * 13   - enter
             * 16   - shift
             * 18   - alt
             * 20   - caps
             * 27   - esc
             * 37   - left arrow
             * 38   - up arrow
             * 39   - right arrow
             * 40   - down arrow
             * 46   - delete
             **/
            var exclude_keys = [8, 13, 16, 18, 20, 27, 37, 38, 39, 40, 46];

            $('[data-mask]').keyup(function (e) {
                if (exclude_keys.indexOf(e.keyCode) > -1) { return; }

                switch (this.dataset.mask) {
                    case 'digits':
                        var x = this.value.replace(/\D/g, '');
                        this.value = x;
                        break;
                    case 'phone':
                        var x = this.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
                        this.value = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
                        break;
                    case 'ssn': {
                        var x = this.value.replace(/\D/g, '').match(/^(\d{0,3})(\d{0,2})(\d{0,4})/);
                        this.value = !x[2] ? x[1] : x[1] + '-' + x[2] + '-' + x[3];
                    }
                }
            });
        }());

        //Plugin used for form validation
        var parselyOptions = {
            classHandler: function (parsleyField) {
                var $element = parsleyField.$element;
                if ($element.parent().hasClass('select-menu')) {
                    return $element.parent();
                }
                return $element;
            },
            errorsContainer: function (parsleyField) {
                var $element = parsleyField.$element;
                var $fieldContainer = $element.closest('.form-field');
                if ($fieldContainer) {
                    return $fieldContainer;
                }
            }
        };

        //Global function to set form state classes
        var formStates = (function () {
            $formInputs = $('form :input');
            if (!$formInputs.length) { return; }

            $formSelectMenus = $('.select-menu select, .ginput_container_select select');

            function isGFormInput($el) {
                return $el.parent().hasClass('ginput_container') ? $el.parent().parent() : $el;
            }

            function setFilled($input) {
                $input.addClass('filled');
            }

            function removeFilled($input) {
                $input.removeClass('filled');
            }

            function setFocused() {
                $(this).addClass('focused');
            }

            function removeFocused() {
                $(this).removeClass('focused');
            }

            function checkInput(e) {
                if (this.type == 'button' ||
                    this.type == 'range' ||
                    this.type == 'submit' ||
                    this.type == 'radio' ||
                    this.type == 'checkbox' ||
                    this.type == 'reset') { return; }

                var $this = $(this);
                var $parent = $this.parent();
                var is_selectMenu = $parent.hasClass('select-menu') || $parent.hasClass('ginput_container_select');

                var $input = is_selectMenu ? $parent : $this;

                switch (this.type) {
                    case 'select-one':
                    case 'select-multiple':
                        if (this.value !== '') {
                            setFilled($input);
                        } else {
                            removeFilled($input);
                        }
                        break;
                    default:
                        if (this.value !== '') {
                            setFilled($input);
                        } else {
                            removeFilled($input);
                        }
                        break;
                }
            }

            $formInputs.each(checkInput);
            $formInputs.on('change', checkInput);
            $formInputs.on('focus', setFocused);
            $formInputs.on('blur', removeFocused);
            $formSelectMenus.on('focus', setFocused);
            $formSelectMenus.on('blur', removeFocused);

        }());
        return { options: parselyOptions }
    }());

    //Global function top open / close lightboxes
    var PDMLightbox = (function () {
        //Lightbox reset - This lightbox is empty and present on all pages
        var $lightbox = $('.pdm-lightbox--reset');

        //it's content can be filled from various sources
        //after close, the content is wiped
        var $lightbox_content = $('.pdm-lightbox--reset .pdm-lightbox__content');

        $('body').on('click', '[data-lightbox-iframe],[data-lightbox-content],[data-lightbox-target],.lightbox-trigger', function (e) {

            e.preventDefault();

            var iframe = $(this).data('lightbox-iframe');

            if (iframe) {
                var youtubePattern = /(?:http?s?:\/\/)?(?:www\.)?youtu(be\.com\/|\.be\/)(embed\/(.+)(\?.+)?|watch\?v=(.+)(\&.+)?)/g;
                var vimeoPattern = /(?:http?s?:\/\/)?:\/\/(www\.|player\.)?vimeo\.com\/(?:channels\/(?:\w+\/)?|groups\/([^\/]*)\/videos\/|video\/|)(\d+)(?:|\/\?)/g;

                if (youtubePattern.test(iframe)) {
                    classes += ' youtube-vid'

                    replacement = '<div class="spacer"><iframe width="560" height="315" frameborder="0" allowfullscreen src="//www.youtube.com/embed/$3?rel=0&autoplay=1&modestbranding=1&iv_load_policy=3" /></div>';

                    iframe = iframe.replace(youtubePattern, replacement);

                }

                if (vimeoPattern.test(iframe)) {

                    classes += ' vimeo-vid'

                    replacement = '<div class="spacer"><iframe width="560" height="315" frameborder="0" allowfullscreen src="//player.vimeo.com/video/$3?rel=0&autoplay=1&modestbranding=1&iv_load_policy=3" /></div>';

                    iframe = iframe.replace(vimeoPattern, replacement);

                }

                $lightbox_content.html('<div class="video-embed">' + iframe + '</div>');
            } else {
                if ($(this).data('lightbox-content')) {
                    var content = $(this).data('lightbox-content');
                } else if ($(this).data('lightbox-target')) {
                    var target = $(this).data('lightbox-target');
                    var content = $('#' + target).html();
                } else {
                    var content = $(this).next('.lightbox-content').html();
                }
                $lightbox_content.html(content);
            }

            var classes = $(this).data('lightbox-classes');
            $lightbox.addClass('active').addClass(classes);

        });

        function closeModal($lightbox) {
            $lightbox.removeClass('active');
            $('body').removeClass('noScroll');
            //wait before removing classes till lightbox closses
            if ($lightbox.hasClass('pdm-lightbox--reset')) {
                setTimeout(function () {
                    $lightbox.find('.pdm-lightbox__content').empty();
                    $lightbox.attr('class', 'pdm-lightbox pdm-lightbox--reset');
                }, 750);
            }
        }

        function openModal($lightbox) {
            $lightbox.addClass('active');
            $('body').addClass('noScroll');
        }

        function updateModal($lightbox, $content) {
            $lightbox.find('.pdm-lightbox__content').html($content);
        }

        $('.pdm-lightbox').on('click', function (e) {
            if (e.target == this) {
                closeModal($(this));
            }
        });

        $('.pdm-lightbox__close').click(function (e) {
            e.stopPropagation();
            closeModal($(this).closest('.pdm-lightbox'));
        });
        return {
            close: closeModal,
            open: openModal,
            update: updateModal
        };
    }());

    //******************************************************Everything under this is optional, feel free to delete

    var Header = (function () {
        var $body = $('body');
        var $header = $('header.gheader');
        var $nav = $header.find('nav.global');
        var $adminBar = $('#wpadminbar');

        var header_height = 0;
        if ($adminBar.length) { header_height += $adminBar.innerHeight(); }
        if (window.innerWidth < 960) { $nav.css({ marginTop: header_height }); }

        var BurgerMenu = (function () {
            var $burgerMenu = $header.find('.menu-burger');
            var $text = $burgerMenu.find('.menu-burger__text');

            function activate() {
                $burgerMenu.addClass('active').attr('title', 'Close');
                $text.text('Close');
                $nav.addClass('active');
                $body.addClass('no-scroll');

                var styles = { position: 'fixed' };
                if ($adminBar.length) { styles.top = $adminBar.innerHeight(); }

                $header.css(styles);
                $body.css({ marginTop: $header.innerHeight() });
            }

            function reset() {
                $burgerMenu.removeClass('active').attr('title', 'Menu');
                $text.text('Menu');
                $nav.removeClass('active').find('.active').removeClass('active');
                $body.removeClass('no-scroll');

                var styles = { position: 'sticky' };
                if ($adminBar.length) { styles.top = $adminBar.innerHeight() };

                $header.css(styles);
                $body.css({ marginTop: 0 });
            }

            $burgerMenu.click(function () {
                var $this = $(this);

                if ($this.hasClass('active')) { reset(); } else { activate(); }
            });

            return {
                close: reset,
                open: activate
            }
        }());

        var DropdownMenus = (function () {
            var $menus = $('.menu');
            var $dropmenus = $menus.find('.menu-item__dropdown');
            var $mobileArrow = $dropmenus.find('.mobile-arrow');

            function toggleDropdown(e) {

                e.preventDefault();

                var $this = $(this);
                var $menuItem = $this.parent();

                if ($menuItem.hasClass('active')) {
                    $menuItem.removeClass('active');
                } else {
                    $menuItem.addClass('active');
                }
            }

            $mobileArrow.click(toggleDropdown);

        }());

        var StickyHeader = (function () {
            if (!$header.hasClass('sticky')) { return; }

            if (window.scrollY) {
                $header.addClass('sticky--scrolled');
            }

            $(window).on('scroll', function () {

                if (window.scrollY) {
                    $header.addClass('sticky--scrolled');

                } else if (window.scrollY === 0) {
                    $header.removeClass('sticky--scrolled');
                }

                if ($adminBar.length) {
                    $header.css({ top: $adminBar.innerHeight() });
                }

            });
        }());

        window.addEventListener('resize', function () {
            $header.css({ position: 'sticky' });
            BurgerMenu.close();

            var styles = { marginTop: window.innerWidth < 960 ? header_height : 0 };

            $nav.css(styles);
        });

    }());

    var StickToHeader = (function () {
        function init() {
            var $el = $('.js-header-sticky');
            if (!$el.length) { return false; }

            $el.each(function () {
                var $this = $(this);
                var header_height = $('.gheader').innerHeight();
                var $this_pos = $this.offset().top;
                var $wp_adminbar = $('#wpadminbar');

                $(document).on('scroll', function () {

                    header_height = $('.gheader').innerHeight() == header_height ? header_height : $('.gheader').innerHeight();
                    header_height += 32;

                    if ($wp_adminbar.length) {
                        header_height += $wp_adminbar.innerHeight();
                    }

                    $this.toggleClass('is-stuck', (window.scrollY + header_height) >= $this_pos);
                    $this.css('top', header_height).attr('data-header-sticky', $this_pos);
                });
            });

        }

        init();

        return {
            refresh: init
        };

    }());

    var LoadMore = (function () {
        var $loadmore = $('#loadmore');
        if (!$loadmore.length) { return; }

        var $loadmore_text = $loadmore.text();

        $loadmore.click(function () {
            var $this = $(this);
            var $postlist = $this.siblings('.blog-posts');
            var query = WP.query;
            var page = WP.current_page;
            var max = WP.max_page;

            var data = {
                action: 'load_more_posts',
                query: query,
                page: page
            };

            $.ajax({
                url: ajaxURL,
                type: 'post',
                data: data,
                beforeSend: function () {
                    $loadmore.attr('disabled', true).text('Loading Posts');
                },
                error: function (res) {
                    res = JSON.parse(res);
                    console.log(res);
                },
                success: function (posts) {
                    if (posts) {
                        page = WP.current_page++;
                        $loadmore.attr('disabled', false).text($loadmore_text);
                        $postlist.append(posts);
                        LazyLoading.update();

                        if (WP.current_page >= max) { $loadmore.remove(); }
                    } else {
                        $loadmore.remove();
                    }
                }
            });
        });
    }());

    var VerticalSlider = (function () {
        var $section = $('.vertical-slider');
        if (!$section.length) { return; }

        $section.each(function () {
            var $this = $(this);
            var $swiper = $this.find('.swiper');

            var swiper_options = {
                slidesPerView: 1,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                },
                pagination: {
                    el: $swiper.find('.swiper-pagination').get(0),
                    clickable: true
                },
            };

            if (window.innerWidth >= 720) {
                swiper_options.direction = 'vertical';
                swiper_options.pagination.renderBullet = function (index, className) {
                    return '<span class="swiper-pagination-number ' + className + '">' + (index + 1) + "</span>";
                }
            }

            $swiper.css('max-height', $swiper.height() + 'px');

            var swiper = new Swiper($swiper.get(0), swiper_options);
        });
    }());

    var Highlights = (function () {
        var $section = $('.highlights');
        if (!$section.length) { return; }

        $section.each(function () {
            var $this = $(this);
            var $swiper = $this.find('.swiper');

            var swiper_options = {
                slidesPerView: 1.5,
                spaceBetween: 16,
                pagination: {
                    el: $swiper.find('.swiper-pagination').get(0),
                    clickable: true
                },
                navigation: {
                    nextEl: $swiper.find('.swiper-button-next').get(0),
                    prevEl: $swiper.find('.swiper-button-prev').get(0)
                }
            };

            if (window.innerWidth < 720) {
                var swiper = new Swiper($swiper.get(0), swiper_options);
            }
        });
    }());

    var EventSlider = (function () {
        var $section = $('.events-block');
        if (!$section.length) { return; }

        $section.each(function () {
            var $this = $(this);
            var $swiper = $this.find('.swiper');

            var swiper_options = {
                slidesPerView: 1.1,
                spaceBetween: 16,
                scrollbar: {
                    el: $swiper.find('.swiper-scrollbar').get(0),
                },
                pagination: {
                    type: 'fraction',
                    el: $swiper.find('.swiper-pagination').get(0),
                    renderFraction: function (currentClass, totalClass) {
                        return '<span class="' + currentClass + '"></span>' +
                            ' / ' +
                            '<span class="' + totalClass + '"></span>';
                    }
                },
                navigation: {
                    nextEl: $swiper.find('.swiper-button-next').get(0),
                    prevEl: $swiper.find('.swiper-button-prev').get(0)
                },

                breakpoints: {
                    720: {
                        slidesPerView: 4,
                    }
                }
            };

            var swiper = new Swiper($swiper.get(0), swiper_options);

            if (swiper.slides.length <= 4 && window.innerWidth >= 720) {
                $swiper.removeClass('swiper-initialized').find('.swiper-controls').hide();
            }
        });
    }());

    var CardSlider = (function () {
        var $section = $('.card-slider');
        if (!$section.length) { return; }

        $section.each(function () {
            var $this = $(this);
            
            if ($this.closest('.events-block').length) { return; }

            var $swiper = $this.find('.swiper');
            var teamSlide = document.querySelector('.loc-team .cards__list');
            var teamSlideCount = teamSlide ? teamSlide.querySelectorAll('.swiper-slide').length : 0;
            var slidesToShow;

            // If there are 3 slides, show 2, otherwise show 3
            slidesToShow = teamSlideCount <= 3 ? 2 : 3;

            var swiper_options = {
                slidesPerView: teamSlide ? 1 : 1.1,
                spaceBetween: teamSlide ? 5 : 16,
                loop: true,
                scrollbar: {
                    el: $swiper.find('.swiper-scrollbar').get(0),
                },
                pagination: {
                    type: 'fraction',
                    el: $swiper.find('.swiper-pagination').get(0),
                    renderFraction: function (currentClass, totalClass) {
                        return '<span class="' + currentClass + '"></span>' +
                            ' / ' +
                            '<span class="' + totalClass + '"></span>';
                    }
                },
                navigation: {
                    nextEl: $swiper.find('.swiper-button-next').get(0),
                    prevEl: $swiper.find('.swiper-button-prev').get(0)
                },

                breakpoints: {
                    720: {
                        slidesPerView: teamSlide ? slidesToShow : 4,
                    }
                }
            };

            var swiper = new Swiper($swiper.get(0), swiper_options);

            if (swiper.slides.length <= 4 && window.innerWidth >= 720 && !teamSlide) {
                $swiper.removeClass('swiper-initialized').find('.swiper-controls').hide();
            }

        });
    }());

    var productSlider = (function () {
        var $section = $('.products-block');
        if (!$section.length) { return; }

        $section.each(function () {
            var $this = $(this);
            var $swiper = $this.find('.swiper');

            var swiper_options = {
                slidesPerView: 1.1,
                spaceBetween: 16,
                loop: true,
                scrollbar: {
                    el: $swiper.find('.swiper-scrollbar').get(0),
                },
                pagination: {
                    type: 'fraction',
                    el: $swiper.find('.swiper-pagination').get(0),
                    renderFraction: function (currentClass, totalClass) {
                        return '<span class="' + currentClass + '"></span>' +
                            ' / ' +
                            '<span class="' + totalClass + '"></span>';
                    }
                },
                navigation: {
                    nextEl: $swiper.find('.swiper-button-next').get(0),
                    prevEl: $swiper.find('.swiper-button-prev').get(0)
                },
                breakpoints: {
                    960: {
                        slidesPerView: 4,
                    }
                }
            };

            var swiper = new Swiper($swiper.get(0), swiper_options);

            if (swiper.slides.length <= 4 && window.innerWidth >= 960) {
                $swiper.removeClass('swiper-initialized').find('.swiper-controls').hide();
            }

        });
    }());

    var AsSeeIn = (function () {
        var $section = $('.as-see-in');
        if (!$section.length) { return; }

        $section.each(function () {
            var $this = $(this);
            var $swiper = $this.find('.swiper');
            var swiper_options = {
                slidesPerView: 1,
                spaceBetween: 16,
                autoplay: {
                    delay: 5000,
                },
                loop: true,
                pagination: {
                    el: $swiper.find('.swiper-pagination').get(0),
                    type: 'bullets',
                },
                navigation: {
                    nextEl: $swiper.find('.swiper-button-next').get(0),
                    prevEl: $swiper.find('.swiper-button-prev').get(0)
                },
            };

            var swiper = new Swiper($swiper.get(0), swiper_options);

            var $controls = $this.find('.swiper-controls');
            if ($controls.length > 0) {
                var $prevControl = $controls.find('.swiper-button-prev');
                $controls.prepend($prevControl);
            }
        });
    }());

    var TeamMember = (function () {

        var $section = $('.team-slider');
        if (!$section.length) { return; }
        $section.each(function () {
            var $this = $(this);
            var $swiper = $this.find('.swiper');

            var swiper_options = {
                slidesPerView: 1,
                spaceBetween: 16,
                loop: true,
                scrollbar: {
                    el: $swiper.find('.swiper-scrollbar').get(0),
                },
                pagination: {
                    type: 'fraction',
                    el: $swiper.find('.swiper-pagination').get(0),
                    renderFraction: function (currentClass, totalClass) {
                        return '<span class="' + currentClass + '"></span>' +
                            ' / ' +
                            '<span class="' + totalClass + '"></span>';
                    }
                },
                navigation: {
                    nextEl: $swiper.find('.swiper-button-next').get(0),
                    prevEl: $swiper.find('.swiper-button-prev').get(0)
                },
                breakpoints: {
                    960: {
                        slidesPerView: 3,
                    }
                }
            };

            var swiper = new Swiper($swiper.get(0), swiper_options);

            if (swiper.slides.length < 4 && window.innerWidth >= 960) {
                // $swiper.removeClass('swiper-initialized').find('.swiper-controls').hide();
            }

        });

    }());

    var contentIcons = (function () {

        var $section = $('.content-icons-block');

        if (!$section.length) { return; }

        $section.each(function () {

            var $this = $(this);

            var $swiper = $this.find('.swiper.icons-row');
            var $gallery = $this.find('.swiper.content-icons-block__slider');

            var swiper_options = {
                slidesPerView: 1.1,
                spaceBetween: 16,
                loop: true,
                init: false,
                scrollbar: {
                    el: $swiper.find('.swiper-scrollbar').get(0),
                },
                pagination: {
                    type: 'fraction',
                    el: $swiper.find('.swiper-pagination').get(0),
                    renderFraction: function (currentClass, totalClass) {
                        return '<span class="' + currentClass + '"></span>' +
                            ' / ' +
                            '<span class="' + totalClass + '"></span>';
                    }
                },
                navigation: {
                    nextEl: $swiper.find('.swiper-button-next').get(0),
                    prevEl: $swiper.find('.swiper-button-prev').get(0)
                }
            };

            var iconsSwiper = new Swiper($swiper.get(0), swiper_options);

            if (window.innerWidth <= 960) {
                iconsSwiper.init();
            } else {
                $swiper.removeClass('swiper-initialized').find('.swiper-controls').hide();
            }

            var gallery_options = {
                slidesPerView: 1,
                spaceBetween: 16,
                loop: false,
                pagination: {
                    type: 'fraction',
                    el: $gallery.find('.swiper-pagination').get(0),
                    renderFraction: function (currentClass, totalClass) {
                        return '<span class="' + currentClass + '"></span>' +
                            ' / ' +
                            '<span class="' + totalClass + '"></span>';
                    }
                },
                navigation: {
                    nextEl: $gallery.find('.swiper-button-next').get(0),
                    prevEl: $gallery.find('.swiper-button-prev').get(0)
                }
            };

            var gallerySwiper = new Swiper($gallery.get(0), gallery_options);

        });
    }());

    var locHero = (function () {

        var $slider = $('.loc-hero__gallery .swiper');

        if (!$slider.length) { return; }

        var gallery_options = {
            slidesPerView: 1,
            spaceBetween: 16,
            loop: false,
            scrollbar: {
                el: $slider.find('.swiper-scrollbar').get(0),
            },
            pagination: {
                type: 'fraction',
                el: $slider.find('.swiper-pagination').get(0),
                renderFraction: function (currentClass, totalClass) {
                    return '<span class="' + currentClass + '"></span>' +
                        ' / ' +
                        '<span class="' + totalClass + '"></span>';
                }
            },
            navigation: {
                nextEl: $slider.find('.swiper-button-next').get(0),
                prevEl: $slider.find('.swiper-button-prev').get(0)
            }
        };

        var gallerySwiper = new Swiper($slider.get(0), gallery_options);

    }());

    var testimonials = (function () {
        var $section = $('.testimonials-block');
        if (!$section.length) { return; }

        $section.each(function () {
            var $this = $(this);
            var $swiper = $this.find('.swiper');

            var count = $this.find('.swiper-slide').length;

            var swiper_options = {
                slidesPerView: 1,
                spaceBetween: 16,
                loop: true,
                init: false,
                scrollbar: {
                    el: $swiper.find('.swiper-scrollbar').get(0),
                },
                breakpoints: {
                    960: {
                        slidesPerView: 3,
                        spaceBetween: 45,
                    }
                },
                pagination: {
                    type: 'fraction',
                    el: $swiper.find('.swiper-pagination').get(0),
                    renderFraction: function (currentClass, totalClass) {
                        return '<span class="' + currentClass + '"></span>' +
                            ' / ' +
                            '<span class="' + totalClass + '"></span>';
                    }
                },
                navigation: {
                    nextEl: $swiper.find('.swiper-button-next').get(0),
                    prevEl: $swiper.find('.swiper-button-prev').get(0)
                }
            };

            var swiper = new Swiper($swiper.get(0), swiper_options);

            if (count > 3) {
                swiper.init();
            } else if (window.innerWidth <= 960) {
                swiper.init();
            } else {
                $swiper.removeClass('swiper-initialized').find('.swiper-controls').hide();
            }

        });
    }());

    var beforeAfterBlock = (function () {
        var $section = $('.before-after-block');
        if (!$section.length) { return; }

        $section.each(function () {
            var $this = $(this);
            var $swiper = $this.find('.swiper');

            var swiper_options = {
                slidesPerView: 1,
                spaceBetween: 16,
                loop: true,
                scrollbar: {
                    el: $swiper.find('.swiper-scrollbar').get(0),
                },
                pagination: {
                    type: 'fraction',
                    el: $swiper.find('.swiper-pagination').get(0),
                    renderFraction: function (currentClass, totalClass) {
                        return '<span class="' + currentClass + '"></span>' +
                            ' / ' +
                            '<span class="' + totalClass + '"></span>';
                    }
                },
                navigation: {
                    nextEl: $swiper.find('.swiper-button-next').get(0),
                    prevEl: $swiper.find('.swiper-button-prev').get(0)
                }
            };

            var swiper = new Swiper($swiper.get(0), swiper_options);

        });
    }());

    var TreatmentCategorySlider = (function () {
        var $section = $('.treatments-block');
        if (!$section.length) { return; }

        $section.each(function () {
            var $this = $(this);
            var $swiper = $this.find('.swiper');

            var swiper_options = {
                init: false,
                slidesPerView: 4,
                spaceBetween: 16,
                scrollbar: {
                    el: $swiper.find('.swiper-scrollbar').get(0),
                },
                pagination: {
                    type: 'fraction',
                    el: $swiper.find('.swiper-pagination').get(0),
                    renderFraction: function (currentClass, totalClass) {
                        return '<span class="' + currentClass + '"></span>' +
                            ' / ' +
                            '<span class="' + totalClass + '"></span>';
                    }
                },
                navigation: {
                    nextEl: $swiper.find('.swiper-button-next').get(0),
                    prevEl: $swiper.find('.swiper-button-prev').get(0)
                },

                breakpoints: {
                    720: {
                        slidesPerView: 4,
                    }
                }
            };

            var swiper = new Swiper($swiper.get(0), swiper_options);

            if (window.innerWidth <= 720) {
                $swiper.removeClass('swiper-initialized').find('.swiper-controls').hide();
            } else {
                swiper.init();
            }
        });
    }());

    var AccordionHighlights = (function () {
        var $section = $('.accordion-highlights');
        if (!$section.length) { return; }

        $section.each(function () {
            var $this = $(this);
            var $accordions = $this.find('.accordion');

            if (window.innerWidth >= 720) {
                $accordions.on('mouseenter', function (e) {
                    var $this = $(this);
                    if ($this.hasClass('active')) { return; }

                    var $trigger = $this.find('.accordion__trigger');

                    $trigger.trigger('click');
                });
            }
        });
    }());

    var StatsBlock = (function () {
        var $section = $('.stats-block');
        if (!$section.length) { return; }

        $section.each(function () {
            var $this = $(this);
            var $swiper = $this.find('.swiper');

            var swiper_options = {
                slidesPerView: 3,
                spaceBetween: 16,
            };

            if (window.innerWidth <= 720) {
                var swiper = new Swiper($swiper.get(0), swiper_options);
            } else {
                $swiper.removeClass('swiper-initialized').find('.swiper-controls').hide();
            }

        });
    }());

    /* ========================================================================================================================

        Filtering Posts

    ======================================================================================================================== */

    var treatmentsMobile = (function () {
        $(".btn--filters").on('click', function () {
            $(this).parent().find('.treatment-filter-wrapper__inner').addClass('active');
        });

        $(".filters-close .btn").on('click', function () {
            closeTreatments(this);
        });

        $(".apply-filters").on('click', function () {
            closeTreatments(this);
        });

        function closeTreatments(el) {
            $(el).closest(".treatment-filter-wrapper__inner").removeClass('active');
        }

        return {
            closeTreatments: closeTreatments
        };

    }());

    var filteringPosts = (function () {
        if (!$('.treatment-filters').length) { return; }

        var selectedCategories = [];
        var selectedConcerns = [];
        var selectedAreas = [];

        $(".treatment-filters .btn-filter").on('click', function () {
            var section = $(this).closest('section');
            var data = $(this).data();
            var slug = data.slug;
            var taxonomy = data.taxonomy;
            var post_type = data.type;

            if ($(this).hasClass('active')) {
                $(this).removeClass('active');
                $(this).removeClass('hide-me');
                $(this).find('input').prop('checked', false);

                if (taxonomy === 'treatments_cat') {
                    selectedCategories = selectedCategories.filter(category => category !== slug);
                } else if (taxonomy === 'treatable-concern') {
                    selectedConcerns = selectedConcerns.filter(concern => concern !== slug);
                } else if (taxonomy === 'treatment-area') {
                    selectedAreas = selectedAreas.filter(concern => concern !== slug);
                }
            } else {
                $(this).addClass('active');
                $(this).find('input').prop('checked', true);

                if (taxonomy === 'treatments_cat') {
                    selectedCategories.push(slug);
                } else if (taxonomy === 'treatable-concern') {
                    selectedConcerns.push(slug);
                } else if (taxonomy === 'treatment-area') {
                    selectedAreas.push(slug);
                }
            }

            filterPosts(selectedCategories, selectedConcerns, selectedAreas, post_type, taxonomy);
        });

        function filterPosts(categories, concerns, areas, post_type, taxonomy) {
            $.ajax({
                type: 'POST',
                url: '/wp-admin/admin-ajax.php',
                dataType: 'html',
                data: {
                    action: 'filter_posts',
                    post_type: post_type,
                    categories: categories,
                    concerns: concerns,
                    areas: areas,
                    reset: false,
                    taxonomy: taxonomy // Include the taxonomy in the request
                },
                beforeSend: function () {
                    $('.loadmore-container').addClass('loading');
                },
                success: function (res) {
                    $('.loadmore-container').html(res);
                    lazyLoadInstance = new LazyLoad();

                    var count = $('.treatment-archive-card').length;

                    $('.results-count').text(count);

                    // Loop through each treatment archive card
                    /*       $('.treatment-archive-card').each(function () {

                     var cardCats = this.dataset.cat;

                     console.log("Card cats " + cardCats);

              
                    var cardConcerns = $(this).data('concerns');

                    $('.treatment-filters .btn-filter').each(function () {
                        var filterCat = $(this).data('slug');

                         var ids = this.dataset.slug;

                       if (!cardCats.includes(filterCat)) {
                            $(this).addClass('hide-me'); 
                        }

                    });
                });
*/
                    // Check if there are any active checkboxes
                    var anyActiveCheckboxes = $('.treatment-filters .btn-filter.active').length > 0;

                    // If no checkboxes are active, remove the 'hide-me' class from relevant elements
                    if (!anyActiveCheckboxes) {
                        $('.btn-filter').removeClass('hide-me');
                    }

                    // Hide Pavigation
                    var pagination = $('.wp-pagenavi');

                    if (anyActiveCheckboxes) {
                        pagination.addClass('hidden');
                    } else {
                        pagination.removeClass('hidden');
                    }

                },
                complete: function () {
                    $('.loadmore-container').removeClass('loading');
                }
            });
        }
    }());

    var ProvidersBlock = (function () {
        var $section = $('.providers-block');
        if (!$section.length) { return; }

        var $provider_list = $section.find('.providers-block__list');
        var $pagination_next = $section.find('.js-providers-block-next');
        var $pagination_prev = $section.find('.js-providers-block-prev');
        var $pagination_page = $section.find('.js-providers-block-page');

        var $location = $section.find('#providers_location');
        var $treatment = $section.find('#providers_treatment');
        var $page = $section.find('#providers_page');

        function getProviders(preSelected) {
            if (document.querySelector('#providers_location').value == '') {
                window.location.href = '/providers';
                return;
            }

            var data = $section.find('#providers').serialize();

            if (typeof preSelected !== 'undefined' && preSelected.length > 0) {
                data = preSelected;
            }

            $.ajax({
                url: ajaxURL,
                type: 'post',
                data: {
                    action: 'load_providers',
                    data: data
                },
                beforeSend: function () {
                    $provider_list.addClass('loading');

                },
                error: function (res) {
                    res = JSON.parse(res);
                    console.log(res);

                },
                success: function (res) {
                    res = JSON.parse(res);

                    if (res.providers) {
                        $section.find('.providers-block__list').html(res.providers);
                        LazyLoading.update();
                        // $pagination_next.attr('data-page', res.next_page).prop('disabled', res.current_page == res.max_pages);
                        // $pagination_prev.attr('data-page', res.prev_page).prop('disabled', res.prev_page <= 1);

                        // $pagination_page.removeClass('active').filter("[data-page='" + res.current_page + "']").addClass('active');

                        // $pagination_page.addClass('hidden');
                        // $pagination_page.filter(function () {
                        //     return $(this).data('page') <= res.max_pages && res.max_pages > 1;
                        // }).removeClass('hidden');
                    }

                },
                complete: function () {
                    $provider_list.removeClass('loading');
                }
            });
        }

        // $pagination_next.click(function () {
        //     var $this = $(this);

        //     $this.attr('disabled', true);
        //     $page.val($this.attr('data-page'));
        //     getProviders();
        // });

        // $pagination_prev.click(function () {
        //     var $this = $(this);

        //     $this.attr('disabled', true);
        //     $page.val($this.attr('data-page'));
        //     getProviders();
        // });

        // $pagination_page.click(function (e) {
        //     e.preventDefault();

        //     var $this = $(this);

        //     $page.val($this.attr('data-page'));

        //     $pagination_page.removeClass('active').filter($this).addClass('active');
        //     getProviders();
        // });

        $location.on('change', function () {
            $page.val(1);
            getProviders();
        });

        $treatment.on('change', function () {
            $page.val(1);
            getProviders();
        });

        var locationParam = urlParams.get('location');

        if (typeof locationParam == 'undefined') { return; }

        var $providerLocationOptions = $('#providers_location option'); 

        $providerLocationOptions.each((index, locationOption) => {
            if(locationOption.value == locationParam) {
                locationOption.selected = true;
                getProviders(`page=1&office=${locationOption.value}`);
            }
        });
    }());

    var megaMenu = (function () {

        var $megaLinks = $('.link-mega-menu');

        if (!$megaLinks.length) { return; }

        var $megamenus = $('.mega-menus');

        $megaLinks.click(function (e) {
            e.preventDefault();

            var $this = $(this);
            var menu = $this.data('menu');

            $megaLinks.removeClass('active');
            $megamenus.removeClass('active');

            $this.addClass('active');
            $megamenus.filter('[data-menu="' + menu + '"]').addClass('active');
            $('body').addClass('mega-menu-active');
        });

        $(document).on('click', '.mega-menu-active', function (e) {
            if (!$(e.target).closest('.gheader').length) {

                $('body').removeClass('mega-menu-active');
                $megaLinks.removeClass('active');
                $megamenus.removeClass('active');
            }
        });

    }());

    var cardGallery = (function () {

        var $gallery = $('.card-gallery');

        if (!$gallery.length) { return; }

        gsap.registerPlugin("ScrollTrigger");

        var $wheel = $gallery.find('.card-gallery__loop');
        var $cards = $gallery.find('.card-gallery__card');
        var $spacers = $cards.find('.spacer');

        //do the math to set all cards in a circle
        var slice = 360 / $cards.length;

        function setup() {
            let radius = $wheel.offsetWidth / 2,
                center = radius,
                DEG2RAD = Math.PI / 180;
            gsap.set($cards, {
                x: i => center + radius * Math.sin(i * slice * DEG2RAD),
                y: i => center - radius * Math.cos(i * slice * DEG2RAD),
                rotation: i => i * slice,
                xPercent: -50,
                yPercent: -50,
                // top: ( (100 / 2) - (100 / $cards.length) / 2 ) + "%",
                // left: ( (100 / 2) - (100 / $cards.length) / 2 ) + "%",
            });
            // gsap.set($spacers, {
            //     width: 100 / $cards.length + "%",
            // });
        }

        setup();

        window.addEventListener("resize", setup);

        gsap.to($wheel, {
            rotate: () => -120,
            ease: "none",
            duration: $cards.length,
            scrollTrigger: {
                trigger: $gallery,
                // markers: true,
                start: 'top center',
                end: 'bottom top',
                // end: 100 * 5 + '%',
                scrub: 1,
                invalidateOnRefresh: true,
            }
        });

    }());

    var CategorySelect = (function () {
        var $category = $('#category');
        if (!$category.length) { return; }

        $category.on('change', function () {
            window.location.href = $(this).val();
        });
    }());

    var gSlider = (function () {

        var $slider = $('.gslider__loop');

        if (!$slider.length) { return; }

        var swiper = new Swiper($slider.get(0), ({
            loop: false,
            slidesPerView: 2,
            spaceBetween: 16,
            scrollbar: {
                el: $slider.find('.swiper-scrollbar').get(0),
            },
            pagination: {
                type: 'fraction',
                el: $slider.find('.swiper-pagination').get(0),
                renderFraction: function (currentClass, totalClass) {
                    return '<span class="' + currentClass + '"></span>' +
                        ' / ' +
                        '<span class="' + totalClass + '"></span>';
                }
            },
            navigation: {
                nextEl: $slider.find('.swiper-button-next').get(0),
                prevEl: $slider.find('.swiper-button-prev').get(0)
            },
            breakpoints: {
                960: {
                    slidesPerView: 4,
                }
            }
        }));

    }());

    var ArchiveFilters = (function () {
        var $filters = $('.archive-filters');
        if (!$filters.length) { return; }

        var $order = $filters.find('#order');
        var $category = $filters.find('#category');

        $order.on('change', function () {
            window.location.href = $(this).val();
        });

        $category.on('change', function () {
            window.location.href = $(this).val();
        });
    }());

    var SidebarPopups = (function () {
        var $triggers = $('.js-sidebar-pop');
        if (!$triggers.length) { return; }

        $triggers.click(function (e) {
            e.preventDefault();
            var $this = $(this);
            var target = $this.data('target');
            var $target = $('#' + target);

            $target.addClass('active');
        });

    }());

    var QuizTrigger = (function () {
        var $triggers = $('.js-quiz-popup').add('[href="#quiz"]');
        if (!$triggers.length) { return; }
        $triggers.click(function (e) {
            e.preventDefault();
            $('#quiz-popup').click();
        });
    }());

    var ConsultationPop = (function () {
        var $triggers = $('.js-consultation-popup').add('[href="#consultation-popup"]');
        if (!$triggers.length) { return; }
        $triggers.click(function (e) {
            e.preventDefault();
            $('#consultation-popup').addClass('active');
        });
    }());

    var PartnershipPop = (function () {
        var $triggers = $('.js-partnership-popup').add('[href="#partnership-popup"]');
        if (!$triggers.length) { return; }
        $triggers.click(function (e) {
            e.preventDefault();
            $('#partnership-popup').addClass('active');
        });
    }());

    var _25OffPop = (function () {
        var $triggers = $('.js-25off-popup').add('[href="#25off-popup"]');
        if (!$triggers.length) { return; }
        $triggers.click(function (e) {
            e.preventDefault();
            $('#25off-popup').addClass('active');
        });
    }());

    var MembershipPop = (function () {
        var $triggers = $('.js-membership-popup').add('[href="#membership-popup"]');
        if (!$triggers.length) { return; }
        $triggers.click(function (e) {
            e.preventDefault();
            $('#membership-popup').addClass('active');
        });
    }());

    var PreSelectTreatmentFilters = (function () {
        var $treatmentFilters = $('.treatment-filters');

        if (!$treatmentFilters.length) { return; }

        var category = urlParams.get('category');

        if (category) {
            $('*[data-slug="' + category + '"]').click();
        }
    }());

    var QuoteSlider = (function () {
        var $section = $('.quote-slider');
        if (!$section.length) { return; }

        $section.each(function () {
            var $slider = $(this).find('.swiper');

            var swiper = new Swiper($slider.get(0), {
                slidesPerView: 1,
                spaceBetween: 16,
                loop: true,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                },
                scrollbar: {
                    el: $slider.find('.swiper-scrollbar').get(0),
                },
                pagination: {
                    type: 'fraction',
                    el: $slider.find('.swiper-pagination').get(0),
                    renderFraction: function (currentClass, totalClass) {
                        return '<span class="' + currentClass + '"></span>' +
                            ' / ' +
                            '<span class="' + totalClass + '"></span>';
                    }
                },
                navigation: {
                    nextEl: $slider.find('.swiper-button-next').get(0),
                    prevEl: $slider.find('.swiper-button-prev').get(0)
                }
            });
        });

    }());

    var PostToC = (function () {
        var $toc = $('.post-toc');
        if (!$toc.length) { return; }

        var $content = $toc.closest('.page-content');
        var $headings = $content.find('h2');
        var $tocList = $toc.find('ul');

        if (!$headings.length) {
            $toc.remove();
            return;
        }

        $headings.each(function () {
            var $this = $(this);
            var id = $this.attr('id') || $this.text().replace(/[^a-zA-Z0-9-]/g, '-').toLowerCase();
            var text = $this.text();

            $this.attr('id', id);

            $tocList.append('<li><a href="#' + id + '">' + text + '</a></li>');
        });

        SmoothScroll.refresh();
    }());

    var FooterScrollAfterThankYou = (function () {
        var $submitConfirmed = $('.gfooter .gform_confirmation_message');

        if (!$submitConfirmed.length) { return; }

        $('html, body').animate({
            scrollTop: $("footer").offset().top
        }, 2000);
    }());

    var EPPopups = (function () {
        var urlHash = location.hash;

        $(document).on('click', '[href*="#ep-"]', function (e) {
            e.preventDefault();
            var $popup = $('#' + this.hash.replace('#ep-', ''));

            $popup.addClass('active');
        });

        // $(document).on('click', '[href*="#ep-"]', function (e) {
        //     e.preventDefault();
        //     var $this = $(this);
        //     var $popup = $(this.hash);

        //     $this.addClass('loading');

        //     if ($popup.hasClass('content-loaded')) {
        //         console.log('ep popup not loaded');
        //         $popup.addClass('active');
        //         $this.removeClass('loading');
        //     } else {
        //         $.ajax({
        //             url: ajaxURL,
        //             type: 'post',
        //             data: {
        //                 action: 'get_ep_popup',
        //                 id: this.hash.replace('#ep-', '')
        //             },
        //             error: function (res) {
        //                 res = JSON.parse(res);
        //                 console.log(res);
        //                 $this.removeClass('loading');
        //             },
        //             success: function (res) {
        //                 res = JSON.parse(res);

        //                 $popup.addClass('content-loaded').find('.pdm-lightbox__content').html(res.ep);

        //                 if ($popup.find('.gform_wrapper form').length) {
        //                     $popup.find('.gform_wrapper form').attr('action', '');
        //                 }

        //                 $popup.addClass('active');
        //                 $this.removeClass('loading');
        //             }
        //         });
        //     }
        // });

        if (urlHash && urlHash.includes('ep-')) {
            var $popup = $(urlHash.replace('#ep-', '#'));

            if (!$popup.length) { return; }
            $popup.addClass('active');

        }

    }());

    var FaqSearch = (function () {
        var $faqSearch = $('#faqSearch');
        if (!$faqSearch.length) { return; }

        $faqSearch.on('input', function () {
            var searchValue = $(this).val().toLowerCase();
            var $faqs = $('.faqs__list .accordion');
            if (!$faqs.length) { return; }

            $faqs.each(function () {
                var $faq = $(this);
                var $faqTitle = $faq.find('.accordion__label');
                var $faqContent = $faq.find('.accordion__content');

                if ($faqTitle.text().toLowerCase().includes(searchValue) || $faqContent.text().toLowerCase().includes(searchValue)) {
                    $faq.show();
                } else {
                    $faq.hide();
                }
            });
        });
    }());

    // This module handles the treatment pricing by location functionality
    var TreatmentPricingByLocation = (function () {
        // Cache DOM elements for performance
        var $treatmentPricingByLocation = $('.treatment-pricing-by-location');
        var $dropdown = $treatmentPricingByLocation.find('.treatment-pricing-by-location__results-dropdown');
        var $dropdownList = $dropdown.find('.result-item');
        var $resultsContent = $treatmentPricingByLocation.find('.treatment-pricing-by-location__results-content');
        var $clearSearch = $treatmentPricingByLocation.find('.search-clear');

        // Exit if dropdown list or treatment pricing section is not found
        if (!$dropdownList.length || !$treatmentPricingByLocation) { return; }

        // Function to clean text by removing HTML tags and extra spaces
        const cleanText = (string) => {
            return string.replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').trim();
        }

        // Function to generate area size elements in the results content
        const generateAreaSizes = (data) => {
            const $areaSizeColumn = $resultsContent.find('.area-size-column');

            $areaSizeColumn.append(`
                <div class="treatment-pricing-by-location__results-content__area-size-inner row">
                    <p class="area-size-name">${data.area_size_name}</p>
                    <p class="areas-list">${data.areas_list}</p>
                </div>
            `);
        };

        // Function to generate the single session pricing column
        const generateSingleSessionColumn = (data) => {
            if (window.innerWidth > 991) {
                if (data.single_session.elite_price === '' && data.single_session.standard_price === '' && data.single_session.guest_price === '') {
                    $resultsContent.find('.single-session-column').hide();
                    return; 
            } else {
                    $resultsContent.find('.single-session-column').show();
                }
            }

            return `
                <div class="row">
                    ${data.single_session.elite_price !== '' ? `
                    <div class="price-container">
                        <h3 class="price-container__title">ELITE</h3>
                        <div class="price-container__price">$${data.single_session.elite_price}</div>
                    </div>
                    ` : ''}
                    ${data.single_session.standard_price !== '' ? `
                    <div class="price-container">
                        <h3 class="price-container__title">STANDARD</h3>
                        <div class="price-container__price">$${data.single_session.standard_price}</div>
                    </div>
                    ` : ''}
                    ${data.single_session.guest_price !== '' ? `
                    <div class="price-container">
                        <h3 class="price-container__title">GUEST</h3>
                        <div class="price-container__price">$${data.single_session.guest_price}</div>
                    </div>
                    ` : ''}
                </div>
            `;
        };

        // Function to generate the unlimited package pricing column
        const generateUnlimitedPackageColumn = (data) => {
            if (window.innerWidth > 991) {
                if (data.unlimited_package.elite_price === '' && data.unlimited_package.standard_price === '' && data.unlimited_package.guest_price === '') {
                    $resultsContent.find('.unlimited-package-column').hide();
                    return;
            } else {
                    $resultsContent.find('.unlimited-package-column').show();
                }
            }

            return `
                <div class="row">
                    ${data.unlimited_package.elite_price !== '' ? `
                    <div class="price-container">
                        <h3 class="price-container__title">ELITE</h3>
                        <div class="price-container__price">$${data.unlimited_package.elite_price}</div>
                    </div>
                    ` : ''}
                    ${data.unlimited_package.standard_price !== '' ? `
                    <div class="price-container">
                        <h3 class="price-container__title">STANDARD</h3>
                        <div class="price-container__price">$${data.unlimited_package.standard_price}</div>
                    </div>
                    ` : ''}
                    ${data.unlimited_package.guest_price !== '' ? `
                    <div class="price-container">
                        <h3 class="price-container__title">GUEST</h3>
                        <div class="price-container__price">$${data.unlimited_package.guest_price}</div>
                    </div>
                    ` : ''}
                </div>
            `;
        };

        // Function to generate a call-to-action button
        const generateCtaButton = (data, isMobile = false) => {
            return `
                <div class="${isMobile ? 'accordion__cta-buttons' : 'row'}">
                    <a href="${data.url}" class="single-session-column__cta-button">${data.title}</a>
                </div>
            `;
        };

        // Function to generate accordion containers for area sizes
        const generateAccordionContainers = (data) => {
            Object.values(data.area_size).forEach((item) => {
                $resultsContent.append(
                    `
                        <div class="accordion-container column">
                            <div class="accordion-container__area-size-column">
                                <p class="area-size-name">${item.area_size_name}</p>
                                <p class="areas-list">${item.areas_list}</p>
                                ${item.single_session.elite_price !== '' || item.single_session.standard_price !== '' || item.single_session.guest_price !== '' ? `
                                <div class="accordion single-session-accordion">
                                    <button class="accordion__trigger" type="button">
                                        <span class="accordion__label">${data.column_headings.column_2.heading !== '' ? data.column_headings.column_2.heading : 'Single Session'} ${data.column_headings.column_2.subheading !== '' ? '(' + data.column_headings.column_2.subheading + ')' : ''} Prices</span>
                                        <span class="accordion__icon"></span>
                                    </button>
                                    <div class="accordion__content">
                                        ${generateSingleSessionColumn(item)}
                                        ${generateCtaButton(data.single_session_cta, true)}
                                    </div>
                                </div>
                                ` : ''}

                                ${item.unlimited_package.elite_price !== '' || item.unlimited_package.standard_price !== '' || item.unlimited_package.guest_price !== '' ? `
                                <div class="accordion unlimited-package-accordion">
                                    <button class="accordion__trigger" type="button">
                                        <span class="accordion__label">${data.column_headings.column_3.heading !== '' ? data.column_headings.column_3.heading : 'Unlimited Package'} ${data.column_headings.column_3.subheading !== '' ? '(' + data.column_headings.column_3.subheading + ')' : ''} Prices</span>
                                        <span class="accordion__icon"></span>
                                    </button>
                                    <div class="accordion__content">
                                        ${generateUnlimitedPackageColumn(item)}
                                        ${generateCtaButton(data.unlimited_package_cta, true)}
                                    </div>
                                </div>
                                ` : ''}
                            </div>
                        </div>
                    `
                );
            });
        };

        const updatePricingColumnHeadings = (data) => {
            $resultsContent.find('.area-size-column .header-row p').html(
                `${data.column_headings.column_1.heading !== '' ? data.column_headings.column_1.heading : 'Area Size'}
                <span>${data.column_headings.column_1.subheading !== '' ? data.column_headings.column_1.subheading : ''}</span>`
            );
            $resultsContent.find('.single-session-column .header-row p').html(
                `${data.column_headings.column_2.heading !== '' ? data.column_headings.column_2.heading : 'Single Session'}
                <span>${data.column_headings.column_2.subheading !== '' ? data.column_headings.column_2.subheading : ''}</span>`
            );
            $resultsContent.find('.unlimited-package-column .header-row p').html(
                `${data.column_headings.column_3.heading !== '' ? data.column_headings.column_3.heading : 'Unlimited Package'}
                <span>${data.column_headings.column_3.subheading !== '' ? data.column_headings.column_3.subheading : ''}</span>`
            );
        }

        // Event listener for dropdown items
        $dropdownList.each(function () {
            var $item = $(this);
            $item.on('click', function () {
                var $data = $item.data();
                var $zip = $data.zip.toString();
                var $state = $data.state;
                var $pricing_list_id = $data.pricingListId;

                // Set the location search input value
                $treatmentPricingByLocation.find('#location_search').val(cleanText($item.text()));

                // Show results content if desktop view
                if (window.innerWidth > 991) {
                    $('.treatment-pricing-by-location__inner').append($resultsContent);
                }

                // Show loading indicator and clear previous results
                $resultsContent.css('display', 'flex');
                $resultsContent.append('<div class="loading"></div>');
                $resultsContent.find('.area-size-column .row').remove();
                $resultsContent.find('.single-session-column .row').remove();
                $resultsContent.find('.unlimited-package-column .row').remove();
                $resultsContent.find('.accordion-container').remove();
                $resultsContent.find('.header-row').hide();
                $clearSearch.show();

                // AJAX request to fetch treatment pricing data
                $.ajax({
                    url: ajaxURL,
                    type: 'post',
                    data: {
                        action: 'treatment_pricing_by_location',
                        zip: $zip,
                        state: $state,
                        pricing_list_id: $pricing_list_id
                    },
                    success: function (res) {
                        $resultsContent.find('.loading').remove();
                        $resultsContent.find('.header-row').show();

                        // Check for desktop or mobile view and generate content accordingly
                        if (window.innerWidth > 991) {
                            Object.values(res.data.area_size).forEach((item) => {
                                generateAreaSizes(item);
                                var unlimitedPackageColumnContent = generateUnlimitedPackageColumn(item);
                                var singleSessionColumnContent = generateSingleSessionColumn(item);
                                
                                $resultsContent.find('.unlimited-package-column').append(unlimitedPackageColumnContent);
                                $resultsContent.find('.single-session-column').append(singleSessionColumnContent);
                            });

                            // Append call-to-action buttons
                            $resultsContent.find('.single-session-column').append(generateCtaButton(res.data.single_session_cta));
                            $resultsContent.find('.unlimited-package-column').append(generateCtaButton(res.data.unlimited_package_cta));
                        } else {
                            // Generate accordion containers for mobile view
                            $resultsContent.append(generateAccordionContainers(res.data));
                            Accordions();
                        }

                        updatePricingColumnHeadings(res.data);
                    },
                    error: function (res) {
                        console.log(res);
                    }
                });
            });
        });

        // Exit if treatment pricing section is not found
        if (!$treatmentPricingByLocation.length) { return; }

        // Event listener for search input
        $treatmentPricingByLocation.find('#location_search').on('input', function () {
            var $input = $(this);
            var searchValue = cleanText($input.val()).toLowerCase();
            $clearSearch.show();

            // Show all items if search input is empty
            if (searchValue.length === 0) {
                $('.result-item').each(function () {
                    $(this).show();
                    $(this).removeClass('filtered');
                    $(this).removeClass('no-border');
                });

                return;
            }

            // Filter dropdown items based on search input
            $dropdownList.each(function () {
                var $item = $(this);
                var $data = $item.data();
                var $zip = $data.zip.toString();
                var $state = $data.state;

                if (($item.text().toLowerCase().includes(searchValue) || $state.includes(searchValue) || $zip.includes(searchValue))) {
                    $item.addClass('filtered');
                    $item.show();
                } else {
                    $item.removeClass('filtered');
                    $item.hide();
                }
            });

            // Manage border visibility for filtered items
            if ($('.filtered').length <= 1) {
                $('.filtered').each(function () {
                    $(this).addClass('no-border');
                });
            } else {
                $('.filtered').each(function () {
                    $(this).removeClass('no-border');
                });
            }
        });

        // Event listener for window click to manage dropdown visibility
        $(window).on('click', function (e) {
            if (!$(e.target).is('#location_search')) {
                $dropdown.removeClass('active');
            } else if ($(e.target).is('#location_search') && $dropdown.hasClass('active')) {
                $dropdown.removeClass('active');
            } else {
                $dropdown.addClass('active');
            }
        });

        // Event listener for clear search button
        $clearSearch.on('click', function () {
            $treatmentPricingByLocation.find('#location_search').val('');
            $resultsContent.hide();
            $resultsContent.find('.area-size-column .row').remove();
            $resultsContent.find('.single-session-column .row').remove();
            $resultsContent.find('.unlimited-package-column .row').remove();
            $resultsContent.find('.accordion-container').remove();
            $resultsContent.find('.header-row').hide();
            $clearSearch.hide();
            $dropdown.removeClass('active');

            // Reset dropdown items to show all
            $dropdownList.each(function () {
                $(this).removeClass('filtered');
                $(this).removeClass('no-border');
                $(this).show();
            });
            
        });
    }());


});